import React, { useState } from "react";
import { motion } from "framer-motion";
import BeforeAfterSlider from "@/components/site/BeforeAfterSlider";
import { useT } from "@/context/LanguageContext";

export default function BeforeAfter({ pairs = [] }) {
  const { t, ui } = useT();
  const [idx, setIdx] = useState(0);
  if (!pairs.length) return null;
  const active = pairs[idx];

  return (
    <section
      className="relative bg-[color:var(--gcs-emerald)] text-[color:var(--gcs-ivory)] py-24 md:py-40 with-grain overflow-hidden"
      data-testid="before-after-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("ba.chapter")}</p>
            <span className="font-serif italic text-6xl md:text-7xl text-[color:var(--gcs-gold)]/50">
              /{String(pairs.length).padStart(2, "0")}
            </span>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-[color:var(--gcs-ivory)]">
              {ui("ba.h1_a")}<em className="text-[color:var(--gcs-gold)]">{ui("ba.h1_em")}</em>{ui("ba.h1_b")}
            </h2>
            <p className="mt-6 text-[color:var(--gcs-ivory)]/70 max-w-xl leading-relaxed">{ui("ba.lead")}</p>
          </div>
        </div>

        <motion.div
          key={active.id || idx}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <BeforeAfterSlider
            beforeUrl={active.before_url}
            afterUrl={active.after_url}
            caption={t(active.caption)}
            beforeLabel={ui("ba.before")}
            afterLabel={ui("ba.after")}
            testid={`ba-${idx}`}
          />
        </motion.div>

        {pairs.length > 1 && (
          <div className="mt-8 flex flex-wrap gap-2" data-testid="ba-tabs">
            {pairs.map((p, i) => (
              <button
                key={p.id || i}
                onClick={() => setIdx(i)}
                className={`text-xs px-4 py-2 rounded-full transition-colors duration-500 border ${
                  i === idx
                    ? "bg-[color:var(--gcs-gold)] text-[color:var(--gcs-emerald)] border-[color:var(--gcs-gold)]"
                    : "border-[color:var(--gcs-ivory)]/30 text-[color:var(--gcs-ivory)] hover:bg-[color:var(--gcs-ivory)]/10"
                }`}
                data-testid={`ba-tab-${i}`}
              >
                {ui("ba.case")} {String(i + 1).padStart(2, "0")}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
